"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeUpTelcoPathName = exports.PORTS = exports.getAdabyronConstants = exports.PROCESS_NAME = exports.PREFIX_TO_APPLY = void 0;
exports.PREFIX_TO_APPLY = {
    CLIENT: "/cliente/api/",
    OPEN: "/abierto/api/",
};
exports.PROCESS_NAME = {
    CLIENT: "ADABYRON-API",
    OPEN: "ADABYRON-API-OPEN",
};
/**
 * Devuelve el processName y prefix
 * @param {string} userType -> Puede ser Telco o ''
 * @returns {object} processName y prefixToApply
 */
const getAdabyronConstants = (userType, isClientArea = true) => {
    let processName = exports.PROCESS_NAME.OPEN;
    let prefixToApply = exports.PREFIX_TO_APPLY.OPEN;
    if (isClientArea || (userType && userType === "Telco")) {
        processName = exports.PROCESS_NAME.CLIENT;
        prefixToApply = exports.PREFIX_TO_APPLY.CLIENT;
    }
    return { processName, prefixToApply };
};
exports.getAdabyronConstants = getAdabyronConstants;
// Por defecto el puerto es el 11010
exports.PORTS = {
    CERRADO: ":11010",
    ABIERTO: ":11020",
};
/**
 * Devuelve el processName y prefix
 * @param {string} path -> URL inicial
 * @param {string} version -> Version de api de TELCO
 * @param {string} idRequest
 * @param {string} host
 * @param {string} port -> Cambia el puerto por defecto cerrado(DEV)
 * @param {string} prefixToApply
 * @param {string} queryParams -> Parametros a concatenar en la url
 * @param {string} urlParamsToReplace -> Parametros a sustituir en la url
 * @returns {object} URL a la que hacer la request
 */
const makeUpTelcoPathName = ({ path, version, idRequest, host, port, prefixToApply, queryParams, urlParamsToReplace, }) => {
    const pathBegin = path.substring(0, path.indexOf("/"));
    const pathEnd = path.substring(path.indexOf("/") + 1, path.length);
    let hostTouse = host;
    if (hostTouse && hostTouse.includes(":11010") && port && port === exports.PORTS.ABIERTO) {
        hostTouse = hostTouse.replace(":11010", port);
    }
    let finalEndpoint = `${hostTouse}${prefixToApply}${pathBegin}/`;
    if (version) {
        finalEndpoint = `${finalEndpoint}v${version}/`;
    }
    finalEndpoint = `${finalEndpoint}${pathEnd}?${idRequest}`;
    if (queryParams && Array.isArray(queryParams) && queryParams.length > 0) {
        for (const queryParam of queryParams) {
            const { param, value } = queryParam;
            if (param) {
                if (!Object.prototype.hasOwnProperty.call(queryParam, "value")) {
                    finalEndpoint += `&${param}`;
                }
                else if (value !== undefined) {
                    finalEndpoint += `&${param}=${String(value)}`;
                }
            }
        }
    }
    if (urlParamsToReplace &&
        Array.isArray(urlParamsToReplace) &&
        urlParamsToReplace.length > 0) {
        urlParamsToReplace.forEach((paramToReplace) => {
            const { param, value } = paramToReplace;
            finalEndpoint = finalEndpoint.replace(param, String(value));
        });
    }
    return finalEndpoint;
};
exports.makeUpTelcoPathName = makeUpTelcoPathName;
exports.default = exports.makeUpTelcoPathName;
//# sourceMappingURL=index.js.map